// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__-Imd2","lastUpdated":"PrivacyPolicy_lastUpdated__1DYft"};